module.exports = __webpack_public_path__ + "img/no-data.5ba13bb9.svg";